<template>
  <div class="package-status-card">
    <label class="label">สถานะแพ็กเกจ</label>

    <div class="status-row">
      <div class="status-box">
        <div
          class="status-icon sale-icon"
          :class="isAvailableForSale ? 'open' : 'closed'"
        >
          <i class="fas fa-shopping-bag"></i>
        </div>
        <div class="status-info">
          <div class="status-title">สถานะ:</div>
          <div class="status-value" :class="{ danger: !isAvailableForSale }">
            {{
              isAvailableForSale
                ? "แพ็กเกจเปิดขายแล้ว"
                : "แพ็กเกจปิดขายแล้ว"
            }}
          </div>
        </div>
        <div class="status-toggle">
          <div
            class="toggle-btn success"
            :class="{ active: isAvailableForSale, disabled: disabled }"
            role="button"
            :tabindex="disabled ? -1 : 0"
            @click="handleChangeIsAvailableForSale(true)"
            @keyup.enter="handleChangeIsAvailableForSale(true)"
          >
            เปิดขาย
          </div>
          <div
            class="toggle-btn danger"
            :class="{ active: !isAvailableForSale, disabled: disabled }"
            role="button"
            :tabindex="disabled ? -1 : 0"
            @click="handleChangeIsAvailableForSale(false)"
            @keyup.enter="handleChangeIsAvailableForSale(false)"
          >
            ปิดขาย
          </div>
        </div>
      </div>

      <div class="status-box">
        <div
          class="status-icon visibility-icon"
          :class="isVisibleOnApp ? 'shown' : 'hidden'"
        >
          <i :class="isVisibleOnApp ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
        </div>
        <div class="status-info">
          <div class="status-title">สถานะ:</div>
          <div class="status-value">
            {{
              isVisibleOnApp
                ? "แพ็กเกจกำลังแสดงในแอปฯ"
                : "แพ็กเกจกำลังซ่อนจากแอปฯ"
            }}
          </div>
        </div>
        <div class="status-toggle">
          <div
            class="toggle-btn info"
            :class="{
              active: isVisibleOnApp,
              disabled: disabled || !isAvailableForSale,
            }"
            role="button"
            :tabindex="disabled || !isAvailableForSale ? -1 : 0"
            @click="handleChangeIsVisibleOnApp(true)"
            @keyup.enter="handleChangeIsVisibleOnApp(true)"
          >
            แสดงในแอปฯ
          </div>
          <div
            class="toggle-btn"
            :class="{
              active: !isVisibleOnApp,
              disabled: disabled || !isAvailableForSale,
            }"
            role="button"
            :tabindex="disabled || !isAvailableForSale ? -1 : 0"
            @click="handleChangeIsVisibleOnApp(false)"
            @keyup.enter="handleChangeIsVisibleOnApp(false)"
          >
            ซ่อนจากแอปฯ
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PackageStatusCard",
  props: {
    isAvailableForSale: {
      type: Boolean,
      default: false,
    },
    isVisibleOnApp: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleChangeIsAvailableForSale(isAvailableForSale) {
      if (this.disabled) return;
      this.$emit("update:isAvailableForSale", isAvailableForSale);
      if (!isAvailableForSale) {
        this.$emit("update:isVisibleOnApp", false);
      }
    },
    handleChangeIsVisibleOnApp(isVisibleOnApp) {
      if (this.disabled || !this.isAvailableForSale) return;
      this.$emit("update:isVisibleOnApp", isVisibleOnApp);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.package-status-card {
  background-color: $white;
  border: 1px solid #e0e0e0;
  border-radius: 15px;
  padding: $space;

  .label {
    display: block;
    margin-bottom: 16px;
    font-size: 1rem;
    font-weight: bold;
  }
}

.status-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.status-box {
  flex: 1 1 320px;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 16px;
}

.status-icon {
  flex: none;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 16px;

  &.sale-icon {
    &.open {
      background-color: #e3f6ed;
      color: $success-color;
    }

    &.closed {
      background-color: #fdeceb;
      color: $danger-color;
    }
  }

  &.visibility-icon {
    &.shown {
      background-color: #e6f4fd;
      color: $secondary-color;
    }

    &.hidden {
      background-color: #f2f2f2;
      color: $warm-grey;
    }
  }
}

.status-info {
  flex: 1;
  min-width: 0;
}

.status-title {
  font-size: 12px;
  font-weight: bold;
  color: $dark;
}

.status-value {
  font-size: 14px;
  font-weight: bold;
  color: $dark;
  white-space: nowrap;

  &.danger {
    color: $danger-color;
  }
}

.status-toggle {
  flex: none;
  display: flex;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f2f2f2;
}

.toggle-btn {
  display: flex;
  align-items: center;
  border: none;
  border-radius: 0;
  background-color: #f2f2f2;
  color: $warm-grey;
  font-size: 13px;
  font-weight: bold;
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
  border-radius: 6px;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &.active {
    background-color: $white;
    color: $dark;
    box-shadow: inset 0 0 0 1px $dark;
  }

  &.success.active {
    color: $success-color;
    box-shadow: inset 0 0 0 1px $success-color;
  }

  &.danger.active {
    color: $danger-color;
    box-shadow: inset 0 0 0 1px $danger-color;
  }

  &.info.active {
    color: $secondary-color;
    box-shadow: inset 0 0 0 1px $secondary-color;
  }
}
</style>
